(function () {
  var STORAGE_KEY = 'florence_recently_viewed';
  var MAX_ITEMS = 8;

  function getList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* localStorage unavailable, skip silently */
    }
  }

  function recordView(product) {
    if (!product || !product.handle) return;
    var list = getList().filter(function (p) {
      return p.handle !== product.handle;
    });
    list.unshift(product);
    if (list.length > MAX_ITEMS) list = list.slice(0, MAX_ITEMS);
    saveList(list);
  }

  function buildItem(p) {
    var li = document.createElement('li');
    li.className = 'florence-quick-switch__item';
    var a = document.createElement('a');
    a.href = p.url;
    if (p.image) {
      var img = document.createElement('img');
      img.src = p.image;
      img.alt = p.title || '';
      img.width = 80;
      img.height = 80;
      img.loading = 'lazy';
      a.appendChild(img);
    }
    var titleSpan = document.createElement('span');
    titleSpan.className = 'florence-quick-switch__title';
    titleSpan.textContent = p.title || '';
    a.appendChild(titleSpan);
    var priceSpan = document.createElement('span');
    priceSpan.className = 'florence-quick-switch__price';
    priceSpan.textContent = p.price || '';
    a.appendChild(priceSpan);
    li.appendChild(a);
    return li;
  }

  function render() {
    var container = document.querySelector('.florence-recently-viewed');
    var dataScript = document.querySelector('[data-florence-current-product]');
    if (!container || !dataScript) return;

    var current;
    try {
      current = JSON.parse(dataScript.textContent);
    } catch (e) {
      current = null;
    }
    recordView(current);

    var list = getList()
      .filter(function (p) {
        return !current || p.handle !== current.handle;
      })
      .slice(0, 6);
    if (!list.length) return;

    var ul = container.querySelector('ul');
    list.forEach(function (p) {
      ul.appendChild(buildItem(p));
    });
    container.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
